import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Spinner from '@atlaskit/spinner';
import { Button as WPLButton, Icon } from '@atlassiansox/wpl-utils';
import { TRACKING_EVENT_NAMES } from '../../utils/constants';
import { buttonWrapper, containerStyle, descriptionStyle, dividerStyle, footerContainerStyle, headerContainerStyle, headerStyle, spinnerContainerStyle, taxSubtextStyle, totalValueStyle } from './entitlements-popup.styles';
import { ErrorState } from './error-state';
const EntitlementsPopup = ({ addPaymentDetailsURL, analyticsAttributes, children, formattedTotalPrice, hasError, isLoading }) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const handleAddPaymentDetails = () => {
        createAnalyticsEvent({
            eventName: TRACKING_EVENT_NAMES.wacCartAddPaymentDetailsButtonClicked,
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'wacCartAddPaymentDetails',
            attributes: analyticsAttributes
        }).fire();
    };
    useEffect(() => {
        createAnalyticsEvent({
            eventName: TRACKING_EVENT_NAMES.wacCartPopoverViewed,
            action: 'viewed',
            actionSubjectId: 'wacCartPopover',
            attributes: analyticsAttributes
        }).fire();
    }, []);
    if (hasError) {
        return (_jsx("div", { css: containerStyle, children: _jsx(ErrorState, { analyticsAttributes: analyticsAttributes }) }));
    }
    if (isLoading) {
        return (_jsx("div", { css: spinnerContainerStyle, children: _jsx(Spinner, { size: "xlarge" }) }));
    }
    return (_jsxs("div", { css: containerStyle, children: [_jsxs("div", { css: headerContainerStyle, children: [_jsx(Icon, { name: "exclamation", size: "xs" }), _jsx("h3", { css: headerStyle, children: "Action required" })] }), _jsx("div", { css: descriptionStyle, children: "To avoid product deactivation, add your payment details now. Your payment details will be stored in your account for the following plans and any future purchases you make." }), _jsx("div", { css: dividerStyle }), _jsx("div", { children: children }), _jsx("div", { css: dividerStyle }), _jsxs("div", { css: footerContainerStyle, children: [_jsx("div", { children: "Monthly total" }), _jsx("div", { css: totalValueStyle, children: formattedTotalPrice })] }), _jsx("div", { css: taxSubtextStyle, children: "(excluding tax)" }), _jsx("div", { css: buttonWrapper, children: _jsx(WPLButton, { text: "Add payment details", color: "green", onClick: handleAddPaymentDetails, url: addPaymentDetailsURL }) })] }));
};
export { EntitlementsPopup };
//# sourceMappingURL=entitlements-popup.js.map